import React, { useState } from 'react';
import { 
  Link2, 
  Server, 
  User, 
  Lock, 
  Building2,
  CheckCircle,
  AlertCircle,
  Save,
  Trash2,
  ArrowLeft,
} from 'lucide-react';
import { useStore } from '../context/StoreContext';
import { useNavigate } from 'react-router-dom';
import MetaApi from 'metaapi.cloud-sdk';

// Get token from environment - with fallback
const HARDCODED_TOKEN = 'eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiIwYTY2NzM5YWRlMDRmYjE2ZDE3ZjIxNmM5ZWM5NDFjZiIsImFjY2Vzc1J1bGVzIjpbeyJpZCI6InRyYWRpbmctYWNjb3VudC1tYW5hZ2VtZW50LWFwaSIsIm1ldGhvZHMiOlsidHJhZGluZy1hY2NvdW50LW1hbmFnZW1lbnQtYXBpOnJlc3Q6cHVibGljOio6KiJdLCJyb2xlcyI6WyJyZWFkZXIiLCJ3cml0ZXIiXSwicmVzb3VyY2VzIjpbIio6JFVTRVJfSUQkOioiXX0seyJpZCI6Im1ldGFhcGktcmVzdC1hcGkiLCJtZXRob2RzIjpbIm1ldGFhcGktYXBpOnJlc3Q6cHVibGljOio6KiJdLCJyb2xlcyI6WyJyZWFkZXIiLCJ3cml0ZXIiXSwicmVzb3VyY2VzIjpbIio6JFVTRVJfSUQkOioiXX0seyJpZCI6Im1ldGFhcGktcnBjLWFwaSIsIm1ldGhvZHMiOlsibWV0YWFwaS1hcGk6d3M6cHVibGljOio6KiJdLCJyb2xlcyI6WyJyZWFkZXIiLCJ3cml0ZXIiXSwicmVzb3VyY2VzIjpbIio6JFVTRVJfSUQkOioiXX0seyJpZCI6Im1ldGFhcGktcmVhbC10aW1lLXN0cmVhbWluZy1hcGkiLCJtZXRob2RzIjpbIm1ldGFhcGktYXBpOndzOnB1YmxpYzoqOioiXSwicm9sZXMiOlsicmVhZGVyIiwid3JpdGVyIl0sInJlc291cmNlcyI6WyIqOiRVU0VSX0lEJDoqIl19LHsiaWQiOiJtZXRhc3RhdHMtYXBpIiwibWV0aG9kcyI6WyJtZXRhc3RhdHMtYXBpOnJlc3Q6cHVibGljOio6KiJdLCJyb2xlcyI6WyJyZWFkZXIiLCJ3cml0ZXIiXSwicmVzb3VyY2VzIjpbIio6JFVTRVJfSUQkOioiXX0seyJpZCI6InJpc2stbWFuYWdlbWVudC1hcGkiLCJtZXRob2RzIjpbInJpc2stbWFuYWdlbWVudC1hcGk6cmVzdDpwdWJsaWM6KjoqIl0sInJvbGVzIjpbInJlYWRlciIsIndyaXRlciJdLCJyZXNvdXJjZXMiOlsiKjokVVNFUl9JRCQ6KiJdfSx7ImlkIjoiY29weWZhY3RvcnktYXBpIiwibWV0aG9kcyI6WyJjb3B5ZmFjdG9yeS1hcGk6cmVzdDpwdWJsaWM6KjoqIl0sInJvbGVzIjpbInJlYWRlciIsIndyaXRlciJdLCJyZXNvdXJjZXMiOlsiKjokVVNFUl9JRCQ6KiJdfSx7ImlkIjoibXQtbWFuYWdlci1hcGkiLCJtZXRob2RzIjpbIm10LW1hbmFnZXItYXBpOnJlc3Q6ZGVhbGluZzoqOioiLCJtdC1tYW5hZ2VyLWFwaTpyZXN0OnB1YmxpYzoqOioiXSwicm9sZXMiOlsicmVhZGVyIiwid3JpdGVyIl0sInJlc291cmNlcyI6WyIqOiRVU0VSX0lEJDoqIl19LHsiaWQiOiJiaWxsaW5nLWFwaSIsIm1ldGhvZHMiOlsiYmlsbGluZy1hcGk6cmVzdDpwdWJsaWM6KjoqIl0sInJvbGVzIjpbInJlYWRlciJdLCJyZXNvdXJjZXMiOlsiKjokVVNFUl9JRCQ6KiJdfV0sImlnbm9yZVJhdGVMaW1pdHMiOmZhbHNlLCJ0b2tlbklkIjoiMjAyMTAyMTMiLCJpbXBlcnNvbmF0ZWQiOmZhbHNlLCJyZWFsVXNlcklkIjoiMGE2NjczOWFkZTA0ZmIxNmQxN2YyMTZjOWVjOTQxY2YiLCJpYXQiOjE3NzI0NjQyMjZ9.SyEw47dBxqKbjifZUSriLVRtxXGT4uTD-oUCjTy3noT0dAEpZFiSmxjROlOTvnvTaOQSdclzmS2okRSpYrVOHQLmSuF8CNKYMm_iay8IBojYSV5P4qZrjhlI0zua--kxQ2B_hIxBC494lHVvK7AGGBxpc2DLjgDpxOBey5AF9LMF2XQOoxrghLeb3XCxSORuZpO1jgBaWVh-f8MqK9A6AXdQFDNlIsp3Nf2QnsH3WI2v0TXxeaU1VJCint8NrDZGO3Fm-XmiddpLJ4hY4JR_TcT-ueFdi8bb7MHcZedAcrcMowRIqBVT0_Js6VhcmfbxfBVKfu5lF-pkkn-0uUh0BoZKY-f0J8JMaYWhhzijzpueZ-9xFRZR74KYY-cyUd_AEsRZdbxxkt4wBx6cQpD2phl7YcPZ9IyDpCvqnhawIfjUU_msFbgJ7_ilKIQFmEEAbwzZFbZaWhWLspazjDmHYyiIwxFxRXzSd8xc61vnxcS5-lvpu3neSiaV97Qfp9pvBsD1soWoEVywxQkYMmf6Ppb6r7cDgIVHMi4OrJaiug8AvWKnsu_zjuUAHgnu1iunKUSyy24Hu9M12Ui7upAm2WwIlkiQMqIBDPMOZNzca7VEG8ZiTYNJmA983wU-6rNX6HI0y8sqcuoDYGjADAe0CEwNqGNFAOy6Qdp2mucLJj4';

const getMetaApiToken = () => {
  // First try environment variables
  const envToken = process.env.REACT_APP_METAAPI_TOKEN || process.env.REACT_APP_FALLBACK_TOKEN;
  if (envToken) return envToken;
  
  // Fallback to hardcoded token
  console.log('Using hardcoded token fallback');
  return HARDCODED_TOKEN;
};  
export default function ConnectAccount() {
  const { mtAccount, setMtAccount } = useStore();
  const navigate = useNavigate();

  const BROKER_LIST = [
    'MetaQuotes',
    'JustMarkets',
    'HFMarkets',
    'Exness',
    'IC Markets',
    'Pepperstone',
    'FP Markets',
    'Axi',
    'Eightcap',
    'FXTM',
    'Tickmill',
    'Alvexo',
    'RockFort',
    'Blueberry Markets',
    'OANDA',
    'Other'
  ];

  const [formData, setFormData] = useState({
    broker: '',
    customBroker: '',
    server: '',
    login: '',
    password: '',
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(false);

  // Handle input change
  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.server.trim()) newErrors.server = 'Server name is required';
    if (!formData.login.trim()) newErrors.login = 'Login is required';
    else if (!/^\d+$/.test(formData.login.trim())) newErrors.login = 'Login must be numeric';
    if (!formData.password.trim()) newErrors.password = 'Password is required';
    
    if (!formData.broker.trim()) {
      newErrors.broker = 'Broker name is required';
    } else if (formData.broker === 'Other' && !formData.customBroker.trim()) {
      newErrors.customBroker = 'Please enter custom broker name';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Test connection with real MetaApi SDK
  const testConnection = async () => {
    setVerifying(true);
    try {
      console.log('Connecting to MetaApi with:', {
        login: formData.login.trim(),
        server: formData.server.trim()
      });
      
      // Debug: Check token availability
      const token = getMetaApiToken();
      console.log('Token available:', !!token);
      console.log('Token type:', typeof token);
      console.log('Token constructor:', token?.constructor?.name);
      console.log('Token is primitive string:', typeof token === 'string');
      
      // Ensure it's a primitive string
      const primitiveToken = String(token);
      console.log('Primitive token type:', typeof primitiveToken);
      
      // Use MetaApi SDK directly (v27 syntax)
      const api = new MetaApi(primitiveToken);

      // Get all accounts (SDK v27 method)
      const accounts = await api.metatraderAccountApi.getAccount([]);
      const accs = accounts._data;
      
      // Find account by login
      const matched = accs.find((acc) => acc.login === formData.login.trim());
      
      if (!matched) {
        throw new Error('Account not found. Please check your login.');
      }
      
      const account = await api.metatraderAccountApi.getAccount(matched._id);
      
      // Deploy if needed
      if (['DEPLOYING', 'UNDEPLOYED'].includes(account.state)) {
        await account.deploy();
        await account.waitDeployed({ timeoutInSeconds: 120 });
      }
      
      // Wait for connection
      await account.waitConnected({ timeoutInSeconds: 180 });
      
      if (account.connectionStatus !== 'CONNECTED') {
        throw new Error(`Connection failed: ${account.connectionStatus}`);
      }
      
      console.log('MetaApi connected successfully');
      return true;
    } catch (err) {
      console.error('MetaApi connection error:', err);
      throw err;
    } finally {
      setVerifying(false);
    }
  };

  // Handle connect
  const handleConnect = async () => {
    if (!validateForm()) return;

    setVerifying(true);
    try {
      const isValid = await testConnection();
      
      if (isValid) {
        const accountData = {
          platform: 'MT5',
          broker: formData.broker === 'Other' ? formData.customBroker.trim() : formData.broker,
          server: formData.server.trim(),
          login: formData.login.trim(),
          password: formData.password.trim(),
          connectedAt: new Date().toISOString(),
          isVerified: true,
        };

        setMtAccount(accountData);
      }
    } catch (err) {
      alert(err.message || 'Connection failed');
    } finally {
      setVerifying(false);
    }
  };

  // Handle save without verification
  const handleSaveWithoutVerification = async () => {
    if (!validateForm()) return;

    setLoading(true);
    try {
      const accountData = {
        platform: 'MT5',
        broker: formData.broker === 'Other' ? formData.customBroker.trim() : formData.broker,
        server: formData.server.trim(),
        login: formData.login.trim(),
        password: formData.password.trim(),
        connectedAt: new Date().toISOString(),
        isVerified: false,
      };

      setMtAccount(accountData);
    } catch (err) {
      alert('Failed to save account details.');
    } finally {
      setLoading(false);
    }
  };

  // Handle disconnect
  const handleDisconnect = () => {
    if (window.confirm('Are you sure you want to remove this account?')) {
      setMtAccount(null);
      setFormData({ broker: '', customBroker: '', server: '', login: '', password: '' });
    }
  };

  // If account is already connected, show success screen
  if (mtAccount) {
    return (
      <div className="min-h-screen bg-theme flex items-center justify-center p-4">
        <div className="max-w-md w-full relative">
          <button
            onClick={() => navigate('/license')}
            className="absolute left-0 top-0 p-2 rounded-lg hover:bg-theme-muted transition-colors"
          >
            <ArrowLeft className="w-5 h-5 text-theme-secondary" />
          </button>
          <div className="card text-center">
            <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-green-500/10 flex items-center justify-center">
              {mtAccount.isVerified ? (
                <CheckCircle className="w-10 h-10 text-green-500" />
              ) : (
                <AlertCircle className="w-10 h-10 text-amber-500" />
              )}
            </div>
            
            <h2 className="text-2xl font-bold text-theme mb-2">
              MT5 Account {mtAccount.isVerified ? 'Connected' : 'Saved'}
            </h2>
            
            <p className="text-theme-secondary mb-6">
              {mtAccount.isVerified 
                ? 'Your account is verified and ready for trading.'
                : 'Account saved locally. Some features may require verification.'
              }
            </p>

            <div className="bg-theme-muted rounded-xl p-4 mb-6 space-y-3 text-left">
              <div className="flex items-center gap-3">
                <Server className="w-4 h-4 text-theme-muted" />
                <span className="text-sm text-theme-secondary">Server: <strong className="text-theme">{mtAccount.server}</strong></span>
              </div>
              <div className="flex items-center gap-3">
                <User className="w-4 h-4 text-theme-muted" />
                <span className="text-sm text-theme-secondary">Login: <strong className="text-theme">{mtAccount.login}</strong></span>
              </div>
              <div className="flex items-center gap-3">
                <Building2 className="w-4 h-4 text-theme-muted" />
                <span className="text-sm text-theme-secondary">Broker: <strong className="text-theme">{mtAccount.broker}</strong></span>
              </div>
              <div className="flex items-center gap-3">
                {mtAccount.isVerified ? (
                  <CheckCircle className="w-4 h-4 text-green-500" />
                ) : (
                  <AlertCircle className="w-4 h-4 text-amber-500" />
                )}
                <span className={`text-sm ${mtAccount.isVerified ? 'text-green-500' : 'text-amber-500'}`}>
                  Status: <strong>{mtAccount.isVerified ? 'Verified' : 'Not Verified'}</strong>
                </span>
              </div>
            </div>

            {!mtAccount.isVerified && (
              <button
                onClick={handleConnect}
                disabled={verifying}
                className="btn-primary w-full mb-3 flex items-center justify-center gap-2"
              >
                <CheckCircle className="w-5 h-5" />
                {verifying ? 'Verifying...' : 'Verify Connection'}
              </button>
            )}

            <button
              onClick={() => navigate('/license')}
              className="btn-secondary w-full mb-3 flex items-center justify-center gap-2"
            >
              Continue to Dashboard
            </button>

            <button
              onClick={handleDisconnect}
              className="w-full py-3 border-2 border-red-500/30 text-red-500 rounded-xl font-semibold hover:bg-red-500/10 transition-colors flex items-center justify-center gap-2"
            >
              <Trash2 className="w-5 h-5" />
              Disconnect Account
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Connection form
  return (
    <div className="min-h-screen bg-theme py-12 px-4">
      <div className="max-w-md mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <button
            onClick={() => navigate('/license')}
            className="absolute left-4 top-4 p-2 rounded-lg hover:bg-theme-muted transition-colors"
          >
            <ArrowLeft className="w-5 h-5 text-theme-secondary" />
          </button>
          <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-ocean-light/10 flex items-center justify-center">
            <Link2 className="w-8 h-8 text-ocean-light" />
          </div>
          <h1 className="text-3xl font-extrabold text-theme mb-2">Connect Trading Account</h1>
          <p className="text-theme-secondary">Enter your existing MT5 account credentials</p>
        </div>

        {/* Form */}
        <div className="card">
          {/* Broker Name */}
          <div className="mb-4">
            <label className="block text-sm font-semibold text-theme mb-2">
              Broker Name
            </label>
            <div className="relative">
              <Building2 className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-theme-muted z-10 pointer-events-none" />
              <select
                className={`select-field pl-11 ${errors.broker ? 'border-red-500 focus:ring-red-500' : ''}`}
                value={formData.broker}
                onChange={(e) => handleChange('broker', e.target.value)}
              >
                <option value="" className="bg-gray-50 dark:bg-dark-surfaceMuted">Select a broker</option>
                {BROKER_LIST.map((broker) => (
                  <option key={broker} value={broker} className="bg-gray-50 dark:bg-dark-surfaceMuted">
                    {broker}
                  </option>
                ))}
              </select>
            </div>
            {errors.broker && <p className="text-red-500 text-xs mt-1">{errors.broker}</p>}
          </div>

          {/* Custom Broker Name (shown when 'Other' is selected) */}
          {formData.broker === 'Other' && (
            <div className="mb-4 animate-fadeIn">
              <label className="block text-sm font-semibold text-theme mb-2">
                Custom Broker Name
              </label>
              <div className="relative">
                <Building2 className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-theme-muted z-10 pointer-events-none" />
                <input
                  type="text"
                  className={`input-field pl-11 ${errors.customBroker ? 'border-red-500 focus:ring-red-500' : ''}`}
                  placeholder="Enter broker name"
                  value={formData.customBroker}
                  onChange={(e) => handleChange('customBroker', e.target.value)}
                />
              </div>
              {errors.customBroker && <p className="text-red-500 text-xs mt-1">{errors.customBroker}</p>}
            </div>
          )}

          {/* Server Name */}
          <div className="mb-4">
            <label className="block text-sm font-semibold text-theme mb-2">
              Server Name
            </label>
            <div className="relative">
              <Server className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-theme-muted" />
              <input
                type="text"
                className={`input-field pl-11 ${errors.server ? 'border-red-500' : ''}`}
                placeholder="e.g. MetaQuotes-Demo5"
                value={formData.server}
                onChange={(e) => handleChange('server', e.target.value)}
              />
            </div>
            {errors.server && <p className="text-red-500 text-xs mt-1">{errors.server}</p>}
            <p className="text-xs text-theme-muted mt-1">Common demo: MetaQuotes-Demo</p>
          </div>

          {/* Account Login */}
          <div className="mb-4">
            <label className="block text-sm font-semibold text-theme mb-2">
              Account Login
            </label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-theme-muted" />
              <input
                type="text"
                className={`input-field pl-11 ${errors.login ? 'border-red-500' : ''}`}
                placeholder="Numeric account login"
                value={formData.login}
                onChange={(e) => handleChange('login', e.target.value)}
              />
            </div>
            {errors.login && <p className="text-red-500 text-xs mt-1">{errors.login}</p>}
          </div>

          {/* Password */}
          <div className="mb-6">
            <label className="block text-sm font-semibold text-theme mb-2">
              Password
            </label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-theme-muted" />
              <input
                type="password"
                className={`input-field pl-11 ${errors.password ? 'border-red-500' : ''}`}
                placeholder="Trading password (not investor)"
                value={formData.password}
                onChange={(e) => handleChange('password', e.target.value)}
              />
            </div>
            {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password}</p>}
          </div>

          {/* Buttons */}
          <div className="space-y-3">
            <button
              onClick={handleConnect}
              disabled={verifying || loading}
              className="btn-primary w-full flex items-center justify-center gap-2"
            >
              <Link2 className="w-5 h-5" />
              {verifying ? 'Verifying...' : 'Verify & Connect'}
            </button>

            <button
              onClick={handleSaveWithoutVerification}
              disabled={loading || verifying}
              className="btn-secondary w-full flex items-center justify-center gap-2"
            >
              <Save className="w-5 h-5" />
              {loading ? 'Saving...' : 'Save for Later'}
            </button>
          </div>

          {/* Security Note */}
          <div className="mt-6 p-3 bg-green-500/10 rounded-xl flex items-start gap-2">
            <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" />
            <p className="text-xs text-green-400">
              Your credentials are stored securely on your device only.
            </p>
          </div>

          {/* Info Note */}
          <div className="mt-3 p-3 bg-blue-500/10 rounded-xl flex items-start gap-2">
            <AlertCircle className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
            <p className="text-xs text-blue-400">
              This connects to your existing broker account. You need valid MT5 credentials from your broker.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
